import { api } from "../services/api.js";

export async function getReporteFlota(fecha, id_supervisor, id_cliente) {
  try {
    let ruta = `/reportes/flota?fecha='${fecha}'`;

    ruta += id_supervisor ? `&id_supervisor=${id_supervisor}` : "";
    ruta += id_cliente ? `&id_cliente=${id_cliente}` : "";

    const response = await api.get(ruta);

    return response.data;
  } catch (error) {
    console.error("Error al obtener el reporte flota:", error);
    throw error;
  }
}
